import { get } from 'lodash'
import { CoreMetricItem } from './CoreItem'
import FeatureLineChart from './LineChart'
import type { CoreMetrics, DataItem, MetricType } from './types'
import { coreMetrics } from './consts'
import { useState } from 'react'
import { cn, isEcommerceProject } from '@/lib/utils'
import { useTranslations } from 'next-intl'
import * as EcommerceMetricView from './EcommerceMetricView'
import { usePostHogParam } from './hooks/usePostHogContext'
import { useProjectStore } from '@/hooks/use-project-store'

export interface CoreViewProps {
  metrics?: CoreMetrics
  activeMetricType: MetricType
  setActiveMetricType: (activeMetricType: MetricType) => void
}

export function CoreView(props: CoreViewProps) {
  const { metrics, activeMetricType = 'visitors', setActiveMetricType } = props
  const t = useTranslations('analytics')
  const { setEventName } = usePostHogParam()
  const { project } = useProjectStore()
  const [datasetMap, setDatasetMap] = useState<Record<MetricType, DataItem[]>>({
    ...(metrics?.datasets || { visitors: [], pageviews: [] }),
    revenue: [],
    orders: [],
    aov: [],
    AddToCart: [],
    Purchase: [],
    InitiateCheckout: [],
  })
  return (
    <div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4 md:gap-6 mt-6 mb-6">
        {coreMetrics.map((key) => (
          <CoreMetricItem
            key={key}
            title={t(key as 'visitors' | 'pageviews')}
            className={cn('h-28 min-w-0', {
              'bg-white/20 border-white/30': activeMetricType === key,
            })}
            onClick={() => {
              setEventName?.('$pageview')
              setActiveMetricType(key as MetricType)
            }}
          >
            <div className="text-xl md:text-2xl truncate">
              {get(metrics, [key]) ?? '--'}
            </div>
          </CoreMetricItem>
        ))}
        {isEcommerceProject(project!) && (
          <>
            <EcommerceMetricView.RevenueMetric
              activeMetricType={activeMetricType}
              setActiveMetricType={(metricType, metricData) => {
                setActiveMetricType(metricType)
                setDatasetMap({
                  ...datasetMap,
                  [metricType]: metricData,
                })
              }}
            />
            <EcommerceMetricView.ReportMetric
              activeMetricType={activeMetricType}
              setActiveMetricType={(metricType, metricData) => {
                setActiveMetricType(metricType)
                setDatasetMap({
                  ...datasetMap,
                  [metricType]: metricData,
                })
              }}
            />
          </>
        )}
      </div>
      <FeatureLineChart
        dataset={datasetMap[activeMetricType]}
        title={t(activeMetricType as MetricType)}
        valueLabel={t(activeMetricType as MetricType)}
      />
    </div>
  )
}
